import { useEffect, useState } from "react";
import {
  SistemaCadastroDto,
  SistemaFiltrarDto,
  SubModuloEnum,
  TipoConfiguracaoEnum,
} from "../../Configuracoes/Sistema/Sistema.Dto";
import { AutenticacaoModule } from "src/Contexto/auth";
import { ConfiguracaoFiltrar } from "src/services/Fiscal.Service";

const CTeConfiguracaoCode = () => {
  const [configuracao, setConfiguracao] = useState<SistemaCadastroDto[]>([]);
  const [loading, setLoading] = useState(false);
  const { userId } = AutenticacaoModule();

  const CACHE_KEY = "cteConfiguracoes" + userId;
  const CACHE_EXPIRATION_TIME = 30 * 60 * 1000;

  useEffect(() => {
    const controller = new AbortController();
    const Load = async () => {
      const cachedData = localStorage.getItem(CACHE_KEY);

      if (cachedData) {
        const parsedData = JSON.parse(cachedData);
        const currentTime = new Date().getTime();

        if (currentTime - parsedData.timestamp < CACHE_EXPIRATION_TIME) {
          setConfiguracao(parsedData.data);
          return;
        } else {
          localStorage.removeItem(CACHE_KEY);
        }
      }
      if (!userId || Number(userId) === 0) {
        return;
      }

      setLoading(true);
      const inputCTe: SistemaFiltrarDto = {
        subModulo: SubModuloEnum.CTe,
        usuarioId: userId.toString(),
      };
      const inputEmpresa: SistemaFiltrarDto = {
        subModulo: SubModuloEnum.Empresa,
      };

      try {
        const [responseCTe, responseEmpresa] = await Promise.all([
          ConfiguracaoFiltrar(inputCTe),
          ConfiguracaoFiltrar(inputEmpresa),
        ]);

        const dataCTe =
          responseCTe.data?.success && Array.isArray(responseCTe.data.data)
            ? (responseCTe.data.data as SistemaCadastroDto[])
            : [];
        const dataEmpresa =
          responseEmpresa.data?.success && Array.isArray(responseEmpresa.data.data)
            ? (responseEmpresa.data.data as SistemaCadastroDto[])
            : [];

        const combinedData = [...dataCTe, ...dataEmpresa];
        const cacheObject = {
          data: combinedData,
          timestamp: new Date().getTime(),
        };
        localStorage.setItem(CACHE_KEY, JSON.stringify(cacheObject));
        setConfiguracao(combinedData);
      } catch (error) {
        console.error("Erro ao carregar configurações do CT-e:", error);
      } finally {
        setLoading(false);
      }
    };
    Load();
    return () => {
      controller.abort();
    };
  }, [userId]);

  const getConfiguracaoValor = (tipo: TipoConfiguracaoEnum) => {
    const item = configuracao.find(
      (item) => String(item.tipoConfiguracao) === String(tipo)
    );
    if (!item) {
      if (tipo === TipoConfiguracaoEnum.RNTRC) return "";
      return "1";
    }
    return item.configuracaoValor;
  };

  return {
    configuracao,
    loading,
    getConfiguracaoValor,
  };
};

export default CTeConfiguracaoCode;
